import { http } from '@/utils/http';
import Store from '@/store/index';

// 获取 mysql 数据库的信息
export const reqFetchMysqlInfo = (connToken) =>
  http.request({
    url: `/v1/mysql/detail`,
    method: 'GET',
    params: connToken
  });

// 数据库列表
export const reqExecSql = (sqlStr,database) =>{
  let param = {
    ConnToken: Store.getters['source/connToken'],
    Sql: sqlStr,
    DataBase: database
  };
  return http.request({
    url: `/v1/mysql/exec`,
    method: 'POST',
    data: param
  });
}
export const reqCharacters = () =>{
  let param = {
    ConnToken: Store.getters['source/connToken']
  }
  return http.request({
    url: `/v1/mysql/listsCharacters`,
    method: 'GET',
    params: param
  });
}
/*export const reqCharacters = () =>{
  let param = {
    ConnToken: Store.getters['source/connToken']
  }
  return http.request({
    url: `/v1/mysql/listsCharacters`,
    method: 'GET',
    params: param
  });
}*/

